<script lang="ts">
  import type { HTMLAttributes } from 'svelte/elements'

  type Props = HTMLAttributes<HTMLDivElement> & {
    layout?: 'split' | 'default'
  }

  const {
    children,
    class: className,
    layout = 'default',
    ...rest
  }: Props = $props()
</script>

<div
  class={['content', layout, className ?? '']}
  {...rest}
>
  {@render children?.()}
</div>

<style lang="scss">
  .content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .split {
    flex-direction: row;
    gap: 1rem;

    :global(> :first-child) {
      flex: 1;
    }

    :global(> :last-child) {
      width: 4.875rem;
    }
  }
</style>
